import { NavigateByPathCommand } from '../commands/navigate-by-path.command.model';
import { OpenInvationModalCommand } from '../commands/open-invitation-modal.command.model';
import { OperationType } from '../operation-type.enum';
import { OperationWithCommand } from '../operation-with-command.model';
import { InviteDriverPayload } from '../payloads/invite-driver.payload.model copy';

export class InviteDriverOperation extends OperationWithCommand {
    static operationTypeStatic = OperationType.InviteDriver;
    operationType = OperationType.InviteDriver;
    payload = new InviteDriverPayload();
    queueCommands = [
      new NavigateByPathCommand(),
      new OpenInvationModalCommand(),
    ];
}
